// French regions, departments and major cities

export const ILE_DE_FRANCE = [
  { code: "75", name: "Paris", short: "Paris" },
  { code: "77", name: "Seine-et-Marne", short: "Seine-et-Marne" },
  { code: "78", name: "Yvelines", short: "Yvelines" },
  { code: "91", name: "Essonne", short: "Essonne" },
  { code: "92", name: "Hauts-de-Seine", short: "Hauts-de-Seine" },
  { code: "93", name: "Seine-Saint-Denis", short: "Seine-Saint-Denis" },
  { code: "94", name: "Val-de-Marne", short: "Val-de-Marne" },
  { code: "95", name: "Val-d'Oise", short: "Val-d'Oise" },
];

export const MAJOR_CITIES = [
  { name: "Paris", slug: "paris", department: "75" },
  { name: "Lyon", slug: "lyon", department: "69" },
  { name: "Marseille", slug: "marseille", department: "13" },
  { name: "Toulouse", slug: "toulouse", department: "31" },
  { name: "Nice", slug: "nice", department: "06" },
  { name: "Cannes", slug: "cannes", department: "06" },
  { name: "Toulon", slug: "toulon", department: "83" },
  { name: "Nantes", slug: "nantes", department: "44" },
  { name: "Bordeaux", slug: "bordeaux", department: "33" },
  { name: "Lille", slug: "lille", department: "59" },
  { name: "Rennes", slug: "rennes", department: "35" },
  { name: "Strasbourg", slug: "strasbourg", department: "67" },
  { name: "Montpellier", slug: "montpellier", department: "34" },
  { name: "Nancy", slug: "nancy", department: "54" },
  { name: "Reims", slug: "reims", department: "51" },
  { name: "Le Havre", slug: "le-havre", department: "76" },
];

export const REGIONS = [
  {
    name: "Île-de-France",
    slug: "ile-de-france",
    departments: ["75", "77", "78", "91", "92", "93", "94", "95"],
  },
  {
    name: "Auvergne-Rhône-Alpes",
    slug: "auvergne-rhone-alpes",
    departments: ["01", "03", "07", "15", "26", "38", "42", "43", "63", "69", "73", "74"],
  },
  {
    name: "Provence-Alpes-Côte d'Azur",
    slug: "provence-alpes-cote-dazur",
    departments: ["04", "05", "06", "13", "83", "84"],
  },
  {
    name: "Nouvelle-Aquitaine",
    slug: "nouvelle-aquitaine",
    departments: ["16", "17", "19", "23", "24", "33", "40", "47", "64", "79", "86", "87"],
  },
  {
    name: "Occitanie",
    slug: "occitanie",
    departments: ["09", "11", "12", "30", "31", "32", "34", "46", "48", "65", "66", "81", "82"],
  },
  {
    name: "Hauts-de-France",
    slug: "hauts-de-france",
    departments: ["02", "59", "60", "62", "80"],
  },
  {
    name: "Grand Est",
    slug: "grand-est",
    departments: ["08", "10", "51", "52", "54", "55", "57", "67", "68", "88"],
  },
  {
    name: "Pays de la Loire",
    slug: "pays-de-la-loire",
    departments: ["44", "49", "53", "72", "85"],
  },
  {
    name: "Bretagne",
    slug: "bretagne",
    departments: ["22", "29", "35", "56"],
  },
  {
    name: "Normandie",
    slug: "normandie",
    departments: ["14", "27", "50", "61", "76"],
  },
  {
    name: "Bourgogne-Franche-Comté",
    slug: "bourgogne-franche-comte",
    departments: ["21", "25", "39", "58", "70", "71", "89", "90"],
  },
  {
    name: "Centre-Val de Loire",
    slug: "centre-val-de-loire",
    departments: ["18", "28", "36", "37", "41", "45"],
  },
  {
    name: "Corse",
    slug: "corse",
    departments: ["2A", "2B"],
  },
];

export const DEPARTMENT_NAMES = {
  "01": "Ain", "02": "Aisne", "03": "Allier", "04": "Alpes-de-Haute-Provence",
  "05": "Hautes-Alpes", "06": "Alpes-Maritimes", "07": "Ardèche", "08": "Ardennes",
  "09": "Ariège", "10": "Aube", "11": "Aude", "12": "Aveyron",
  "13": "Bouches-du-Rhône", "14": "Calvados", "15": "Cantal", "16": "Charente",
  "17": "Charente-Maritime", "18": "Cher", "19": "Corrèze", "21": "Côte-d'Or",
  "22": "Côtes-d'Armor", "23": "Creuse", "24": "Dordogne", "25": "Doubs",
  "26": "Drôme", "27": "Eure", "28": "Eure-et-Loir", "29": "Finistère",
  "2A": "Corse-du-Sud", "2B": "Haute-Corse",
  "30": "Gard", "31": "Haute-Garonne", "32": "Gers", "33": "Gironde",
  "34": "Hérault", "35": "Ille-et-Vilaine", "36": "Indre", "37": "Indre-et-Loire",
  "38": "Isère", "39": "Jura", "40": "Landes", "41": "Loir-et-Cher",
  "42": "Loire", "43": "Haute-Loire", "44": "Loire-Atlantique", "45": "Loiret",
  "46": "Lot", "47": "Lot-et-Garonne", "48": "Lozère", "49": "Maine-et-Loire",
  "50": "Manche", "51": "Marne", "52": "Haute-Marne", "53": "Mayenne",
  "54": "Meurthe-et-Moselle", "55": "Meuse", "56": "Morbihan", "57": "Moselle",
  "58": "Nièvre", "59": "Nord", "60": "Oise", "61": "Orne",
  "62": "Pas-de-Calais", "63": "Puy-de-Dôme", "64": "Pyrénées-Atlantiques",
  "65": "Hautes-Pyrénées", "66": "Pyrénées-Orientales", "67": "Bas-Rhin",
  "68": "Haut-Rhin", "69": "Rhône", "70": "Haute-Saône", "71": "Saône-et-Loire",
  "72": "Sarthe", "73": "Savoie", "74": "Haute-Savoie", "75": "Paris",
  "76": "Seine-Maritime", "77": "Seine-et-Marne", "78": "Yvelines",
  "79": "Deux-Sèvres", "80": "Somme", "81": "Tarn", "82": "Tarn-et-Garonne",
  "83": "Var", "84": "Vaucluse", "85": "Vendée", "86": "Vienne",
  "87": "Haute-Vienne", "88": "Vosges", "89": "Yonne", "90": "Territoire de Belfort",
  "91": "Essonne", "92": "Hauts-de-Seine", "93": "Seine-Saint-Denis",
  "94": "Val-de-Marne", "95": "Val-d'Oise",
};
